import cookies from 'js-cookie';

export const LOGIN = 'api/auth/login'; // post
export const REGISTER = 'api/auth/register';
export const FORGET_PASS = 'api/auth/forget-password';
export const RESET_PASS = 'api/auth/change-password';
export const VALIDATE_EMAIL = 'api/auth/verification/verify-account';
export const RESEND_VALIDATE_EMAIL = 'api/auth/verification/resend';
export const GET_STORES = 'api/store';
export const GET_STORES_APP_SCHEDULE = 'api/store/app-schedule';
export const SAVE_STORE = 'api/store'; // post
export const GET_SET_STAFF = (storeID) => `api/store/${storeID}/staff`;
export const GET_SET_SUPPLY = (storeID) => `api/store/${storeID}/supply`;
export const GET_SET_INVENTORY = (storeID) => `api/store/${storeID}/inventory`;
export const GET_SET_CASHIER_BOX = (storeID) => `api/store/${storeID}/cashierbox`;
export const GET_SET_PRODUCTS = 'api/product';
export const GET_SET_SECTIONS = 'api/section';
export const GET_SET_DISCOUNTS = 'api/discounts';
export const GET_AVAILABLE_DISCOUNTS = 'api/availableDiscounts';
export const GET_SET_CUSTOMERS = 'api/customer';
export const GET_SET_ORDERS = 'api/order';
export const GET_SET_ORDERS_CFDI = (orderID) => `api/order/${orderID}/cfdi`;
export const GET_ORDERS_CFDI_PREVIEW = (orderID) => `api/order/${orderID}/preview/cfdi`;
export const GET_SET_CFDI = 'api/cfdi';
export const GET_HEADER_SUMMARY = 'api/orderHeaderSummary';
export const GET_SET_ROUTES_ORDERS = 'api/routes/orders';
export const GET_SET_ROUTES = 'api/routes';
export const GET_STATISTICS = 'api/statistics';
export const GET_SET_ORDERS_PAGE = 'api/ordersPage';
export const GET_ORDERS_PAGE_COUNT = 'api/ordersPage/count';
export const GET_STORE_ROUTES = 'api/storeRoutes';
export const GET_SET_STORE_IMAGE = 'api/store-image';
export const SEND_VOUCHER_EMAIL = 'api/ordersPage/voucherMail';
export const GET_COMPANY_LOGO = 'api/company-logo';
export const GET_SET_COMPANY_ID_v2 = `api/company`;
export const GET_SET_COMPANY_TAX_INFO_v2 = (companyId) => `api/company/${companyId}/taxInfo`;
export const GET_SET_COMPANY_TAX_INFO_CERTIFIES = (companyId) => `api/company/${companyId}/taxInfo/certificates`;
export const GET_SET_COUNTRY = 'api/country';
export const EXPORT_ORDERS_PAGE = 'api/ordersPage/exportOrdersPage';
export const GET_CASH_UP = 'api/cashup';
export const GET_CASH_UP_REPORTS = 'api/cashupreports';
export const GENERATE_CHECKOUT_SESSION = 'api/orders/create-checkout-session';
export const GET_REPORTS = 'api/reports';
export const GENERATE_ORDERS = 'api/demo/generate-orders';
export const GENERATE_EXPORT = 'api/export';
export const GET_SET_CUSTOMERS_PAGE = 'api/customersPage';
export const GET_MY_COMPANY = 'api/info/my-company';
export const GET_SET_PRODUCTS_SUPPLY = 'api/product-supply';
export const GET_SET_REVIEWS = `api/review`;
export const GET_SET_DISCOUNT_CODES = 'api/v2/discountCodes';
export const GET_AVAILABLE_DISCOUNT_CODES = 'api/v2/availableDiscountCodes';
export const GENERATE_SUBSCRIBE_CHECKOUT_SESSION = 'api/stripe/create-subscription-checkout-session';
export const GENERATE_CFDI_SUBSCRIBE_CHECKOUT_SESSION = 'api/stripe/create-cfdi-subscription-checkout-session';
export const GENERATE_CUSTOMER_PORTAL_SESSION = 'api/stripe/create-customer-portal-session';
// export const GET_SAT_PRODUCT_CATALOG = 'api/cfdi/catalogs/products';
export const GET_SET_USER = 'api/user';
export const GET_SET_ORDERS_V2 = 'api/v2/orders';
export const GET_SET_ORDER_V2 = 'api/v2/order';
export const GET_SET_COMPANY = `api/company`;
export const CUSTOMER_BULK = `api/customer/bulk`;
export const GET_SET_COMPANY_SUB_BILLING_INFO = (companyID) => `api/company/${companyID}/suscriptionBillingInfo`;
